module.exports = __webpack_public_path__ + "img/fond-binome.65bf254a.png";